import styled from "styled-components";
import { headingText } from "./style";

const StickyHeaderContainer = styled.div`
    position: fixed;
    top: 0px;
    width: 100%;
    padding: 15px 50px 15px 50px;
    ${headingText}
    font-size: 14pt;
    text-transform: uppercase;
    background-color: rgba(255,255,255,0.98);
    border-bottom: 1px solid #F0F0F0;
    z-index: 2000;
    box-shadow: 2px 2px 3px #C0C0C0;
    opacity: 1;


`;

const StickyHeader = () => {


    return <StickyHeaderContainer>Deconstructing Proxies</StickyHeaderContainer>;
}

export default StickyHeader;